//App
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_PREVIOUS_PAGE = "SET_PREVIOUS_PAGE";
